module.exports = __webpack_public_path__ + "static/media/projet.c813bca2.png";